import { useEffect } from "react";

import config from "@/config";

export default function ZendeskWidget() {
  useEffect(() => {
    if (!config.zendeskKey) return;

    const script = document.createElement("script");
    script.id = "ze-snippet";
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${config.zendeskKey}`;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return null;
}
